import { ChangeDetectionStrategy, Component, Input } from '@angular/core'

@Component({
  selector: 'bmcore-volume-up-icon',
  templateUrl: './bmcore-volume-up-icon.component.html',
  styleUrls: ['./bmcore-volume-up-icon.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class BmcoreVolumeUpIconComponent {
  @Input() color = 'currentColor'
  @Input() width = 24
  @Input() height = 24
}
